import { render, staticRenderFns } from "./Media.vue?vue&type=template&id=24bb5e5f&scoped=true"
import script from "./Media.ts?vue&type=script&lang=ts&external"
export * from "./Media.ts?vue&type=script&lang=ts&external"
import style0 from "./Media.scss?vue&type=style&index=0&id=24bb5e5f&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bb5e5f",
  null
  
)

export default component.exports